import { HttpHeaders } from '@angular/common/http';

export enum StorageCase {
  currentUser = 'currentUser',
  token = 'currentUserToken',
  deviceId = 'deviceId',
  passwordResetToken = 'resetToken',
  fromDate = 'fromDate',
  toDate = 'toDate',
}

export class HeaderConfig {
  headerNoAuth = new HttpHeaders({
    Accept: 'application/json',
  });
  headerAuth = new HttpHeaders({
    Accept: 'application/json',
  });
}
